export default __webpack_public_path__ + "static/media/vitality.c9882853.png";